import { type ReactNode } from 'react';
import { PortalDashboardView } from './PortalDashboardView.js';

/**
 * M42 §27 CustomerPortalDashboard — the customer stakeholder landing surface
 * (§17). Renders the shared responsive dashboard view scoped to the CUSTOMER
 * segment.
 */
export function CustomerPortalDashboard(): ReactNode {
  return <PortalDashboardView segment="Customer" defaultType="CUSTOMER" />;
}
